"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useTheme(theme) {
    react_1.useLayoutEffect(function () {
        // Iterate through each value in theme object
        for (var key in theme) {
            // Update css variables in document's root element
            document.documentElement.style.setProperty("--" + key, theme[key]);
        }
    }, [theme]); // Only call again if theme object reference changes
}
exports.useTheme = useTheme;
